// Índice "número da UC → assinante + titular da fatura", para as listas de
// boletos mostrarem os dois nomes. A regra está em `src/lib/financeiro/nomesDaUc.ts`;
// aqui fica só a busca.
//
// Falha de rede ou RLS NÃO derruba a tela: o índice fica vazio e a lista cai no
// nome gravado na própria fatura, que é o comportamento antigo.

import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { indiceNomesUc, nomesDaFatura, type NomesDaUc, type UcNomes } from '../lib/financeiro/nomesDaUc';

const PAGINA = 1000;
const COLUNAS = 'numero_uc_norm, outro_numero_uc_norm, nome_cliente, titular_fatura';

export async function buscarNomesDasUcs(): Promise<UcNomes[]> {
  const todas: UcNomes[] = [];
  for (let inicio = 0; ; inicio += PAGINA) {
    // `.order('id')`: sem ordem fixa o Postgres pode repetir ou pular linhas entre páginas.
    const { data, error } = await supabase
      .from('unidades_consumidoras')
      .select(COLUNAS)
      .order('id', { ascending: true })
      .range(inicio, inicio + PAGINA - 1);
    if (error) throw error;
    if (!data?.length) break;
    todas.push(...(data as UcNomes[]));
    if (data.length < PAGINA) break;
  }
  return todas;
}

export function useIndiceNomesUc(): (f: { uc_codigo?: string | null; cliente_nome?: string | null }) => NomesDaUc {
  const [indice, setIndice] = useState<Map<string, NomesDaUc>>(new Map());

  useEffect(() => {
    let vivo = true;
    buscarNomesDasUcs()
      .then((ucs) => { if (vivo) setIndice(indiceNomesUc(ucs)); })
      .catch((e) => console.warn('Não foi possível carregar os nomes das UCs; as listas usam o nome da fatura.', e));
    return () => { vivo = false; };
  }, []);

  return useCallback((f) => nomesDaFatura(f, indice), [indice]);
}
